import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi.js";
import AppError from "../domains2/libraries/AppError";
import { store } from "../store";

const RecommendationEngineProvider = {
	async sortProducts(data, tenantId) {
		return BifrostBackendNestApi.post(`/recommendation-engine/_sortProducts`, {
			data,
			tenantId
		})
			.then((res) => {
				return res.data;
			}).catch((err) => {
				throw AppError.createNewError(
					"An error occurred while sorting PRODUCT LISTS from RECOMMENDATION ENGINE",
					err
				);
			});
	},
	async sortCatalogProducts({data}) {
		return BifrostBackendNestApi.post(`/recommendation-engine/_sortCatalogProducts`, data, {
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		})
			.then((res) => {
				return res.data;
			}).catch((err) => {
				throw AppError.createNewError(
					"An error occurred while sorting PRODUCTS in CATALOG PAGES from RECOMMENDATION ENGINE",
					err
				);
			});
	},
	async getRecommendations(data, tenantId) {
		return BifrostBackendNestApi.post(`/recommendation-engine/_obtain`, {
			tenantId,
			data
		})
			.then((res) => {
				return res.data;
			}).catch((err) => {
				throw AppError.createNewError(
					"An error occurred while loading RECOMMENDATIONS from RECOMMENDATION ENGINE",
					err
				);
			});
	},
	async sendFeedback(data, tenantId) {
		return BifrostBackendNestApi.post(`/recommendation-engine/feedback`, {
			tenantId,
			...data
		})
			.then(() => {})
			.catch((err) => {
				throw AppError.createNewError(
					"An error occurred while sending FEEDBACK to RECOMMENDATION ENGINE",
					err
				);
			});
	},
	async obtainBadges(tenantId = 100) {
		return BifrostBackendNestApi.post(`/recommendation-engine/_obtainBadges`, {
			tenantId
		})
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				throw AppError.createNewError(
					"An error occurred while getting BADGES to RECOMMENDATION ENGINE",
					err
				);
			});
	},
	async sendFeedbackBadges(data, tenantId) {
		return BifrostBackendNestApi.post(`/recommendation-engine/feedbackBadges`, {
			tenantId,
			...data
		})
			.then(() => {})
			.catch((err) => {
				throw AppError.createNewError(
					"An error occurred while sending BADGE FEEDBACK to RECOMMENDATION ENGINE",
					err
				);
			});
	}
};
export default Object.freeze(RecommendationEngineProvider);
